import { Loader } from "@googlemaps/js-api-loader";

let _mapsPromise = null;
export const loadMaps = (key) => {
  if (_mapsPromise) return _mapsPromise;
  _mapsPromise = new Loader({ apiKey: key, version: "weekly", libraries: ["geometry", "places"] }).load();
  return _mapsPromise;
};

export const reverseGeocode = async (lat, lng) => {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) return "";
  try {
    await loadMaps(key);
    const gc = new window.google.maps.Geocoder();
    return await new Promise((resolve) => {
      gc.geocode({ location: { lat, lng } }, (res, st) => resolve(st === "OK" && res && res[0] ? res[0].formatted_address : ""));
    });
  } catch { return ""; }
};

export const geocodeAddress = async (address) => {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key || !address) return null;
  try {
    await loadMaps(key);
    const gc = new window.google.maps.Geocoder();
    return await new Promise((resolve) => {
      gc.geocode({ address }, (res, st) => resolve(st === "OK" && res && res[0]
        ? { lat: res[0].geometry.location.lat(), lng: res[0].geometry.location.lng() } : null));
    });
  } catch { return null; }
};

export const getCurrentAddress = async () => {
  if (!navigator.geolocation) return null;
  return await new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const address = await reverseGeocode(pos.coords.latitude, pos.coords.longitude);
        resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, address });
      },
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 8000 }
    );
  });
};
